import { Box, Typography, Sheet } from '@mui/joy';

/**
 * Активность за неделю: 7 столбиков, сегодня выделен. weekly = homepage-data.weekly_activity
 */
const NAVY = '#2A75D3';

export default function WeeklyActivity({ weekly }) {
    const days = Array.isArray(weekly) ? weekly : [];
    const max = Math.max(1, ...days.map(d => d.total_activity || 0));
    return (
        <Sheet variant="outlined" sx={{ p: { xs: 2, sm: 2.25 }, borderRadius: '16px', borderColor: 'divider', bgcolor: 'background.surface' }}>
            <Typography sx={{ fontSize: 17, fontWeight: 700, letterSpacing: '-0.01em', mb: 1.5 }}>Активность за неделю</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1, alignItems: 'end', height: 136 }}>
                {days.map(d => {
                    const v = d.total_activity || 0;
                    const h = v > 0 ? Math.max(8, Math.round((v / max) * 88)) : 4;
                    return (
                        <Box key={d.date} data-testid={`week-day-${d.date}`} data-today={d.is_today ? 'true' : 'false'}
                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: v > 0 ? 'text.primary' : 'text.tertiary', lineHeight: 1 }}>{v}</Typography>
                            <Box data-testid="week-day" sx={{
                                width: '100%', maxWidth: 34, height: h, borderRadius: '6px 6px 3px 3px',
                                bgcolor: v > 0 ? (d.is_today ? NAVY : `${NAVY}66`) : 'divider',
                            }} />
                            <Typography sx={{ fontSize: 11.5, fontWeight: d.is_today ? 700 : 500, color: d.is_today ? NAVY : 'text.tertiary', lineHeight: 1 }}>{d.day_name}</Typography>
                        </Box>
                    );
                })}
            </Box>
            {days.length > 0 && days.every(d => !(d.total_activity > 0)) && (
                <Typography level="body-xs" sx={{ color: 'text.tertiary', mt: 1.5 }}>На этой неделе пока тихо. Один тест в день держит серию.</Typography>
            )}
        </Sheet>
    );
}
